import React, { useState } from 'react';
import { PageShell } from '../../components';
import ProviderForm from './components/ProviderForm';
import { providerService } from '../../services/providerService';
import { ProviderDocumentType } from '../../types/provider';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';

const ProviderCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: any) => {
    setIsSubmitting(true);
    try {
      const { documents, pendingFiles, ...providerData } = data;
      const created = await providerService.createProvider(providerData);
      const newId = String(created.id);

      // Save documents (number/validity) if any
      if (documents && documents.length > 0) {
        try {
          await providerService.saveDocuments(newId, {
            responsibleName: providerData.responsibleName,
            responsibleCRM: providerData.responsibleCRM,
            documents,
          });
        } catch {
          // non-critical
        }
      }

      // Upload pending files if any
      if (pendingFiles && pendingFiles.length > 0) {
        for (const pf of pendingFiles as Array<{ documentType: ProviderDocumentType; file: File }>) {
          try {
            await providerService.uploadDocumentFile(newId, pf.documentType, pf.file);
          } catch {
            // non-critical
          }
        }
      }

      enqueueSnackbar('Prestador cadastrado com sucesso!', { variant: 'success' });
      navigate('/providers');
    } catch (error: unknown) {
      const apiError = error as { response?: { data?: { message?: string } }; message?: string };
      const errorMessage = (apiError.response?.data?.message || apiError.message) ?? 'Erro ao cadastrar prestador';
      enqueueSnackbar(errorMessage, { variant: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/providers');
  };

  return (
    <PageShell
      breadcrumbs={[
        { label: 'Início', path: '/home' },
        { label: 'Prestadores', path: '/providers' },
        { label: 'Cadastrar' },
      ]}
      title="Cadastrar Novo Prestador"
    >
      <ProviderForm onSubmit={handleSubmit} onCancel={handleCancel} isSubmitting={isSubmitting} />
    </PageShell>
  );
};

export default ProviderCreatePage;
